export const LANDING_RENT_REVIEWS = [
  {
    name: 'Roman',
    text: 'RomanReview',
  },
  {
    name: 'Aizhan',
    text: 'AizhanReview',
  },
  {
    name: 'Sergey',
    text: 'SergeyReview',
  },
  {
    name: 'Anna',
    text: 'AnnaReview',
  },
  {
    name: 'Anton',
    text: 'AntonReview',
  },
  {
    name: 'Boris',
    text: 'BorisReview',
  },
  {
    name: 'Alexey',
    text: 'AlexeyReview',
  },
  {
    name: 'Stanislav',
    text: 'StanislavReview',
  },
];
